import {
  ThermalDataType,
  UnitsDataType,
} from "../../interface/dataTypeInterface";

export const unitsData: UnitsDataType[] = [
  {
    id: "unit_names",
    name: "International Sysitem of Units",
    updatedAt: "2022-07-26",
    descriptions: [
      "Base Units are the defining units that all other derived units base upon.",
      "- Time - Coherent unit: second - Symbol: s",
      "- Length - Coherent unit: metre - Symbol: m",
      "- Mass - Coherent unit: kilogram - Symbol: kg",
      "- Electic current - Coherent unit: ampere - Symbol: A",
      "- Thermodynamic temperature - Coherent unit: kelvin - Symbol: K",
      "- Amount of substance - Coherent unit: mole - Symbol: mol",
      "- Luminous intensity - Coherent unit: candela - Symbol: cd",
      "Defining constant: 7 defining constants",
      "- speed of light in vacuum (c) - (299792458 m/s)",
      "- the hyperfine transition frequency of caesium (\u0394\u03bdCs) - (9192631770 Hz)",
      "- the Plancks constant (h) - (6.62607015x10\u207b\u00b3\u2074J\u00B7s)",
      "- the elementary charge (e) - (1.602176634x10\u207b\u00b9\u2079C)",
      "- the Boltzmann constant (k) - (1.380649x10\u207b\u00b2\u00b3/K)",
      "- the Avogrado constant (N\u2090) - (6.02214076x10\u00b2\u00b3 mol\u207b\u00b9) ",
      "- the luminous efficacy (Kcd) - (683 lm/W)",
      "",
    ],
    data: [
      {
        quantity_name: { value: "time" },
        coherent_unit: { value: "second" },
        unit_symbol: { value: "s" },
        in_base_units: { value: "base unit" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "t" },
      },
      {
        quantity_name: { value: "length" },
        coherent_unit: { value: "metre" },
        unit_symbol: { value: "m" },
        in_base_units: { value: "base unit" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "l, h, a, b, x, y, r etc" },
      },
      {
        quantity_name: { value: "mass" },
        coherent_unit: { value: "kilogram" },
        unit_symbol: { value: "kg" },
        in_base_units: { value: "base unit" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "m" },
      },
      {
        quantity_name: { value: "electric current" },
        coherent_unit: { value: "ampere" },
        unit_symbol: { value: "A" },
        in_base_units: { value: "base unit" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "I, i" },
      },
      {
        quantity_name: { value: "thermodynamic temperature" },
        coherent_unit: { value: "kelvin" },
        unit_symbol: { value: "K" },
        in_base_units: { value: "base unit" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "T" },
      },
      {
        quantity_name: { value: "amoung of substance" },
        coherent_unit: { value: "mole" },
        unit_symbol: { value: "mol" },
        in_base_units: { value: "base unit" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "n" },
      },
      {
        quantity_name: { value: "luminous intensity" },
        coherent_unit: { value: "candela" },
        unit_symbol: { value: "cd" },
        in_base_units: { value: "base unit" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "I\u1d65" },
      },
      {
        quantity_name: { value: "plane angle" },
        coherent_unit: { value: "radian" },
        unit_symbol: { value: "rad" },
        in_base_units: { value: "m/m" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03b1, \u03b2, \u03b4 etc" },
      },
      {
        quantity_name: { value: "solid angle" },
        coherent_unit: { value: "steradian" },
        unit_symbol: { value: "sr" },
        in_base_units: { value: "m\u00b2/m\u00b2" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03a9" },
      },
      {
        quantity_name: { value: "frequency" },
        coherent_unit: { value: "hertz" },
        unit_symbol: { value: "hz" },
        in_base_units: { value: "s\u207b\u00b9" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "f, v" },
      },
      {
        quantity_name: { value: "force" },
        coherent_unit: { value: "newton" },
        unit_symbol: { value: "N" },
        in_base_units: { value: "kg\u00B7m/s\u00b2" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "F" },
      },
      {
        quantity_name: { value: "pressure, stress" },
        coherent_unit: { value: "pascal" },
        unit_symbol: { value: "pa" },
        in_base_units: { value: "kg\u00B7m\u207b\u00b9\u00B7s\u207b\u00b2" },
        in_other_SI_units: { value: "N/m\u00b2" },
        typical_symbol: { value: "p, P" },
      },
      {
        quantity_name: { value: "energy, work, heat" },
        coherent_unit: { value: "joule" },
        unit_symbol: { value: "J" },
        in_base_units: { value: "kg\u00B7m\u00b2\u00B7s\u207b\u00b2" },
        in_other_SI_units: { value: "N\u00b7m = Pa\u00b7m\u00b3" },
        typical_symbol: { value: "E" },
      },
      {
        quantity_name: { value: "power, radiant flux" },
        coherent_unit: { value: "watt" },
        unit_symbol: { value: "W" },
        in_base_units: { value: "kg\u00B7m\u00b2\u00B7s\u207b\u00b3" },
        in_other_SI_units: { value: "J/s" },
        typical_symbol: { value: "P" },
      },
      {
        quantity_name: { value: "electric charge" },
        coherent_unit: { value: "coulomb" },
        unit_symbol: { value: "C" },
        in_base_units: { value: "s\u00B7A" },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "q" },
      },
      {
        quantity_name: { value: "electric potential, voltage, emf" },
        coherent_unit: { value: "volt" },
        unit_symbol: { value: "V" },
        in_base_units: {
          value: "kg\u00B7m\u00b2\u00B7s\u207b\u00b3\u00B7A\u207b\u00b9",
        },
        in_other_SI_units: { value: "W/A = J/C" },
        typical_symbol: { value: "V, U" },
      },
      {
        quantity_name: { value: "capacitance" },
        coherent_unit: { value: "farad" },
        unit_symbol: { value: "F" },
        in_base_units: {
          value: "kg\u207b\u00b9\u00B7m\u207b\u00b2\u00B7s\u2074\u00B7A\u00b2",
        },
        in_other_SI_units: { value: "C/V = C\u00b2/J" },
        typical_symbol: { value: "C" },
      },
      {
        quantity_name: { value: "resistance" },
        coherent_unit: { value: "ohm" },
        unit_symbol: { value: "\u03A9" },
        in_base_units: {
          value: "kg\u00B7m\u00b2\u00B7s\u207b\u00b3\u00B7A\u207b\u00b2",
        },
        in_other_SI_units: { value: "V/A = J\u00b7s/C\u00b2" },
        typical_symbol: { value: "G" },
      },
      {
        quantity_name: { value: "electric conductance" },
        coherent_unit: { value: "siemens" },
        unit_symbol: { value: "s" },
        in_base_units: {
          value: "kg\u207b\u00B9\u00B7m\u207b\u00b2\u00B7s\u00b3\u00B7A\u00b2",
        },
        in_other_SI_units: { value: "\u03A9\u207b\u00b9" },
        typical_symbol: { value: "G" },
      },
      {
        quantity_name: { value: "magnetic flux" },
        coherent_unit: { value: "weber" },
        unit_symbol: { value: "Wb" },
        in_base_units: {
          value: "kg\u00B7m\u00b2\u00B7s\u207b\u00b2\u00B7A\u207b\u00b9",
        },
        in_other_SI_units: { value: "V\u00b7s" },
        typical_symbol: { value: "\u03a6" },
      },
      {
        quantity_name: { value: "magnetic flux density" },
        coherent_unit: { value: "tesla" },
        unit_symbol: { value: "T" },
        in_base_units: {
          value: "kg\u00B7s\u207b\u00b2\u00B7A\u207b\u00b9",
        },
        in_other_SI_units: { value: "Wb/m\u00b2" },
        typical_symbol: { value: "B, H" },
      },
      {
        quantity_name: { value: "inbuctance" },
        coherent_unit: { value: "henry" },
        unit_symbol: { value: "H" },
        in_base_units: {
          value: "kg\u00B7m\u00b2\u00B7s\u207b\u00b2\u00B7A\u207b\u00b2",
        },
        in_other_SI_units: { value: "Wb/A" },
        typical_symbol: { value: "L" },
      },
      {
        quantity_name: { value: "temperature relative to 273.15K" },
        coherent_unit: { value: "degree celcius" },
        unit_symbol: { value: "°C" },
        in_base_units: {
          value: "K",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "T" },
      },
      {
        quantity_name: { value: "lumious flux" },
        coherent_unit: { value: "lumen" },
        unit_symbol: { value: "lm" },
        in_base_units: {
          value: "cd\u00B7sr",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03a6\u1d65" },
      },
      {
        quantity_name: { value: "illuminance" },
        coherent_unit: { value: "lux" },
        unit_symbol: { value: "lx" },
        in_base_units: {
          value: "cd\u00B7sr\u00B7m\u207b\u00b2",
        },
        in_other_SI_units: { value: "lm/m\u00b2" },
        typical_symbol: { value: "E\u1d65" },
      },
      {
        quantity_name: {
          value: "activity referred to a radionuclide (dcays per unit time)",
        },
        coherent_unit: { value: "becquerel" },
        unit_symbol: { value: "Bq" },
        in_base_units: {
          value: "s\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value: "absorbed dose (of ionising radiation)",
        },
        coherent_unit: { value: "gray" },
        unit_symbol: { value: "Gy" },
        in_base_units: {
          value: "m\u00b2\u00b7s\u207b\u00b2",
        },
        in_other_SI_units: { value: "J/kg" },
        typical_symbol: { value: "D" },
      },
      {
        quantity_name: {
          value: "equivalent dose (of ionising radiation)",
        },
        coherent_unit: { value: "sievert" },
        unit_symbol: { value: "Sv" },
        in_base_units: {
          value: "m\u00b2\u00b7s\u207b\u00b2",
        },
        in_other_SI_units: { value: "J/kg" },
        typical_symbol: { value: "H" },
      },
      {
        quantity_name: {
          value: "catalytic activity",
        },
        coherent_unit: { value: "katal" },
        unit_symbol: { value: "kat" },
        in_base_units: {
          value: "mol\u00b7s\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value: "area",
        },
        coherent_unit: { value: "square metre" },
        unit_symbol: { value: "m\u00b2" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "A" },
      },
      {
        quantity_name: {
          value: "volume",
        },
        coherent_unit: { value: "cubic metre" },
        unit_symbol: { value: "m\u00b3" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "V" },
      },
      {
        quantity_name: {
          value: "speed, velocity",
        },
        coherent_unit: { value: "metre per second" },
        unit_symbol: { value: "m/s" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "v" },
      },
      {
        quantity_name: {
          value: "acceleration",
        },
        coherent_unit: { value: "metre per second squared" },
        unit_symbol: { value: "m/s\u00b2" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "a" },
      },
      {
        quantity_name: {
          value: "density",
        },
        coherent_unit: { value: "kilogram per cubic metre" },
        unit_symbol: { value: "kg/m\u00b3" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03c1" },
      },
      {
        quantity_name: {
          value: "surface density",
        },
        coherent_unit: { value: "kilogram per quare metre" },
        unit_symbol: { value: "kg/m\u00b2" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03c1\u2090" },
      },
      {
        quantity_name: {
          value: "specific volume",
        },
        coherent_unit: { value: "cubic metre per kilogram" },
        unit_symbol: { value: "m\u00b3/kg" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "v" },
      },
      {
        quantity_name: {
          value: "current density",
        },
        coherent_unit: { value: "ampere per square metre" },
        unit_symbol: { value: "A/m\u00b2" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "j" },
      },
      {
        quantity_name: {
          value: "magnetic field strength",
        },
        coherent_unit: { value: "ampere per metre" },
        unit_symbol: { value: "A/m" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "H" },
      },
      {
        quantity_name: {
          value: "mass concentration",
        },
        coherent_unit: { value: "mole per cubic metre" },
        unit_symbol: { value: "mol/m\u00b3" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03c1, \u0263" },
      },
      {
        quantity_name: {
          value: "luminance",
        },
        coherent_unit: { value: "candela per square metre" },
        unit_symbol: { value: "cd/m\u00b2" },
        in_base_units: {
          value: "coherent derived units",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "L\u1d65" },
      },
      {
        quantity_name: {
          value: "dynamic viscosity",
        },
        coherent_unit: { value: "pascal second" },
        unit_symbol: { value: "Pa\u00B7s" },
        in_base_units: {
          value: "m\u207b\u00b9\u00B7kg\u00B7s\u207b\u00B9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03b7, \u03bc" },
      },
      {
        quantity_name: {
          value: "surface tension",
        },
        coherent_unit: { value: "newton metre" },
        unit_symbol: { value: "N\u00B7m" },
        in_base_units: {
          value: "kg\u00B7s\u207b\u00b2",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03b3, \u03c3, T" },
      },
      {
        quantity_name: {
          value: "angular velocity, angular frequency",
        },
        coherent_unit: { value: "radian per second" },
        unit_symbol: { value: "rad/s" },
        in_base_units: {
          value: "s\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03c9" },
      },
      {
        quantity_name: {
          value: "angular acceleration",
        },
        coherent_unit: { value: "radian per square second" },
        unit_symbol: { value: "rad/s\u00b2" },
        in_base_units: {
          value: "s\u207b\u00b2",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u0251" },
      },
      {
        quantity_name: {
          value: "heat flux density, irradiance",
        },
        coherent_unit: { value: "watt per square metre" },
        unit_symbol: { value: "W/m\u00b2" },
        in_base_units: {
          value: "kg\u00B7s\u207b\u00b3",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "E\u2091" },
      },
      {
        quantity_name: {
          value: "entropy, heat capacity",
        },
        coherent_unit: { value: "joule per kelvin" },
        unit_symbol: { value: "J/K" },
        in_base_units: {
          value: "m\u00b2\u00B7kg\u00B7s\u207b\u00b2\u00b7K\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "S" },
      },
      {
        quantity_name: {
          value: "specific heat capacity, specific entropy",
        },
        coherent_unit: { value: "joule per kilgram kelvin" },
        unit_symbol: { value: "J/(kg\u00b7K)" },
        in_base_units: {
          value: "m\u00b2\u00B7s\u207b\u00b2\u00b7K\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "c\u209a" },
      },
      {
        quantity_name: {
          value: "specific energy",
        },
        coherent_unit: { value: "joule per kilgram" },
        unit_symbol: { value: "J/kg" },
        in_base_units: {
          value: "m\u00b2\u00B7s\u207b\u00b2",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "e" },
      },
      {
        quantity_name: {
          value: "thermal conductivity",
        },
        coherent_unit: { value: "watt per metre kelvin" },
        unit_symbol: { value: "W/(m\u00b7K)" },
        in_base_units: {
          value: "m\u00B7kg\u00b7s\u207b\u00b2",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03ba, \u03bb" },
      },
      {
        quantity_name: {
          value: "energy density",
        },
        coherent_unit: { value: "joule per cubic metre" },
        unit_symbol: { value: "J/m\u00b3" },
        in_base_units: {
          value: "m\u207b\u00b9\u00B7kg\u00b7s\u207b\u00b2",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value: "electric field strength",
        },
        coherent_unit: { value: "volt per metre" },
        unit_symbol: { value: "V/m" },
        in_base_units: {
          value: "m\u00B7kg\u00b7s\u207b\u00b3\u00b7A\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "E" },
      },
      {
        quantity_name: {
          value: "electric charge density",
        },
        coherent_unit: { value: "coloumb per cubic metre" },
        unit_symbol: { value: "C/m\u00b3" },
        in_base_units: {
          value: "m\u207b\u00B3\u00b7s\u00b7A",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value:
            "surface charge density, electric flux density, electic displacement",
        },
        coherent_unit: { value: "coloumb per square metre" },
        unit_symbol: { value: "C/m\u00b2" },
        in_base_units: {
          value: "m\u207b\u00B2\u00b7s\u00b7A",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value: "permittivity",
        },
        coherent_unit: { value: "farad per metre" },
        unit_symbol: { value: "F/m" },
        in_base_units: {
          value: "m\u207b\u00B3\u00b7kg\u207b\u00b9\u00b7s\u2074\u00b7A\u00b2",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03b5" },
      },
      {
        quantity_name: {
          value: "permeability",
        },
        coherent_unit: { value: "henry per metre" },
        unit_symbol: { value: "H/m" },
        in_base_units: {
          value: "m\u00b7kg\u00b7s\u207b\u00b2\u00b7A\u207b\u00b2",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "\u03bc" },
      },
      {
        quantity_name: {
          value: "molar energy",
        },
        coherent_unit: { value: "joule per mole" },
        unit_symbol: { value: "J/mol" },
        in_base_units: {
          value: "m\u00b2\u00b7kg\u00b7s\u207b\u00b2\u00b7mol\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value: "molar entropy, molar heat capacity",
        },
        coherent_unit: { value: "joule per mole kelvin" },
        unit_symbol: { value: "J/(mol\u00b7K)" },
        in_base_units: {
          value:
            "m\u00b2\u00b7kg\u00b7s\u207b\u00b2\u00b7K\u207b\u00b9\u00b7mol\u207b\u00b9",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "S" },
      },
      {
        quantity_name: {
          value: "exposure (x-rays)",
        },
        coherent_unit: { value: "coloumb per kilogram" },
        unit_symbol: { value: "C/kg" },
        in_base_units: {
          value: "kg\u207b\u00b9\u00b7s\u00b7A",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "X" },
      },
      {
        quantity_name: {
          value: "absorbed dose rate",
        },
        coherent_unit: { value: "gray per second" },
        unit_symbol: { value: "Gy/s" },
        in_base_units: {
          value: "m\u00b2\u00b7s\u207b\u00b3",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "D" },
      },
      {
        quantity_name: {
          value: "radiant intensity",
        },
        coherent_unit: { value: "watt per steradian" },
        unit_symbol: { value: "W/sr" },
        in_base_units: {
          value: "m\u00b2\u00b7kg\u00b7s\u207b\u00b3",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value: "radiance",
        },
        coherent_unit: { value: "watt per square metre steradian" },
        unit_symbol: { value: "W/(m\u00b2sr)" },
        in_base_units: {
          value: "kg\u00b7s\u207b\u00b3",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
      {
        quantity_name: {
          value: "catalytic activity concentration",
        },
        coherent_unit: { value: "katal per cubic metre" },
        unit_symbol: { value: "kat/m\u00b3" },
        in_base_units: {
          value: "m\u207b\u00b3\u00b7s\u207b\u00b9\u00b7mol",
        },
        in_other_SI_units: { value: "-" },
        typical_symbol: { value: "-" },
      },
    ],
  },
];
